<template>
  <button
    v-bind="$attrs"
    :class="buttonClasses"
    :disabled="disabled"
    :type="type"
  >
    <IconBase v-if="icon" :icon="icon" :tone="iconTone" :size="size" />

    <slot>
      <span v-if="text" :class="style.text">
        {{ text }}
      </span>
    </slot>
  </button>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import style from "./ButtonBase.module.scss";
import IconBase from "@/elements/UI/icon/IconBase.vue";

export default defineComponent({
  name: "ButtonBase",
  inheritAttrs: false,
  components: {IconBase},
  props: {
    size: {
      type: String as PropType<Size>,
      default: "M"
    },
    icon: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    iconTone: {
      type: String as PropType<IconTone>,
      default: "default"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as PropType<ButtonTypeClick>,
      default: "button"
    }
  },
  data() {
    return {
      style
    };
  },
  computed: {
    hasDefaultSlot(): boolean {
      return Boolean(this.$slots.default);
    },
    isOnlyIconButton(): boolean {
      return Boolean(this.icon && !this.text && !this.hasDefaultSlot);
    },
    buttonClasses(): string[] {
      return [
        style.buttonBase,
        style[`size${this.size}`],
        this.isOnlyIconButton ? style.onlyIconButton : "",
        this.disabled ? style.disabled : ""
      ];
    }
  }
});
</script>
